import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Sidebar.css';

const Sidebar = ({ isOpen, toggleSidebar, user, companyProfile }) => {
  const location = useLocation();
  const [logo, setLogo] = useState('/logo.png');

  useEffect(() => {
    if (companyProfile?.logo) {
      setLogo(companyProfile.logo);
    }
  }, [companyProfile]);

  const menuItems = [
    { path: '/', icon: 'bi-speedometer2', label: 'Dashboard' },
    { path: '/records', icon: 'bi-file-earmark-text', label: 'Records' },
    { path: '/organizations', icon: 'bi-building', label: 'Organizations' },
    { path: '/contacts', icon: 'bi-people', label: 'Contacts' },
    { path: '/projects', icon: 'bi-folder', label: 'Projects' },
    { path: '/stock', icon: 'bi-box-seam', label: 'Stock & Inventory' },
    { path: '/tenders', icon: 'bi-file-earmark-check', label: 'Tenders' },
    { path: '/quotations', icon: 'bi-file-earmark-text', label: 'Quotations' },
    // Sales
    { path: '/sales/delivery-challans', icon: 'bi-truck', label: 'Delivery Challans' },
    { path: '/sales/invoices', icon: 'bi-receipt', label: 'Invoices' },

    { path: '/reports', icon: 'bi-graph-up', label: 'Reports & Analytics' },
    { path: '/users', icon: 'bi-person-gear', label: 'User Management', roles: ['Administrator', 'Manager', 'Auditor'] },
    { path: '/company', icon: 'bi-building-gear', label: 'Company Profile', roles: ['Administrator', 'Auditor'] },
    { path: '/activity-logs', icon: 'bi-clock-history', label: 'Activity Logs', roles: ['Administrator', 'Manager', 'Auditor'] },
  ];

  // define user role safely
  const userRole = user ? user.role : 'Employee'; // Default to least priv if undefined (though ProtectedRoute handles auth)

  return (
    <>
      <div
        className={`sidebar-backdrop ${isOpen ? 'show' : ''}`}
        onClick={toggleSidebar}
      ></div>
      <div className={`sidebar ${isOpen ? 'show' : ''}`}>
        <div className="sidebar-header">
          <div className="d-flex justify-content-end d-lg-none mb-2">
            <button
              className="btn btn-sm btn-link text-white p-0"
              onClick={toggleSidebar}
            >
              <i className="bi bi-x-lg"></i>
            </button>
          </div>
          <div className="text-center mb-3">
            <img
              src={logo}
              alt="Company Logo"
              style={{ height: '110px', width: 'auto', marginBottom: '15px' }}
            />
          </div>
          <small className="text-center d-block fw-bold">Record & Stock Management</small>
        </div>
        <ul className="sidebar-menu">
          {menuItems.filter(item => !item.roles || item.roles.includes(userRole)).map((item) => (
            <li key={item.path}>
              <Link
                to={item.path}
                className={location.pathname === item.path ? 'active' : ''}
                onClick={() => window.innerWidth < 992 && toggleSidebar()}
              >
                <i className={`bi ${item.icon}`}></i>
                <span>{item.label}</span>
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </>
  );
};

export default Sidebar;

